export default "__VITE_ASSET__BJbTc$le__"